/**
 * Shared release-status styling. The list shows a chip, the builder shows a switch — both read from
 * here so the two can never drift into different shades of "the same" state.
 */
export const RELEASE_STATUS = {
  draft: {
    label: 'Entwurf',
    lamp: 'bg-[#D4A72C] shadow-[0_0_0_3px_rgba(212,167,44,0.14)]',
    chip: 'bg-amber-50 text-amber-700 border border-amber-200',
    text: 'text-amber-700'
  },
  released: {
    label: 'Veröffentlicht',
    lamp: 'bg-[#16A34A] shadow-[0_0_0_3px_rgba(22,163,74,0.16)]',
    chip: 'bg-green-50 text-green-700 border border-green-200',
    text: 'text-green-700'
  }
} as const;

export const releaseStatusOf = (isReleased: boolean) => (isReleased ? RELEASE_STATUS.released : RELEASE_STATUS.draft);
